import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
  Card,
  Container,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { BsArrowLeft, BsCheckLg, BsXLg, BsPerson, BsCalendar, BsGenderAmbiguous, BsPersonBadge, BsFileEarmarkText, BsPhone, BsEnvelope, BsGeoAlt, BsCardImage, BsBook } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import ApiEndpoints, { BASE_URL, BASE_URL_Upload } from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

const AddNewTeacher = () => {
  const { user, logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [teacherImage, setTeacherImage] = useState(null)
  const [institute, setInstitute] = useState({ instituteId: '', name: '' })

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    const instituteName = Cookies.get('institute_name')
    setInstitute({ instituteId, name: instituteName })
    setNewTeacher((prev) => ({
      ...prev,
      'institute-Id': Number(instituteId),
    }))
  }, [])

  const [newTeacher, setNewTeacher] = useState({
    name: '',
    dob: '',
    qualification: '',
    phone: '',
    email: '',
    age: '',
    gender: '',
    address: '',
    password: '',
    joining_date: '',
    institute_id: Number(id),
    id_proof_type: '',
    id_proof_number: '',
    designation: 'Teacher',
  })

  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewTeacher((prev) => ({ ...prev, [name]: value }))

    if (name === 'dob') {
      const age = calculateAge(value)
      setNewTeacher((prev) => ({
        ...prev,
        dob: value,
        age: age.toString(),
      }))
    } else {
      setNewTeacher((prev) => ({ ...prev, [name]: value }))
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleSave = async (e) => {
    e.preventDefault()

    try {
      setLoading(true)
      let imageUrl = null
      if (teacherImage) {
        if (teacherImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          setLoading(false)
          return
        }
        const formData = new FormData()
        formData.append('image', teacherImage)
        formData.append('folder', 'teacher')

        const imageResponse = await axios.post(
          BASE_URL + '/upload-image',
          formData,
        )
        if (imageResponse.data && imageResponse.data.path) {
          imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        } else {
          throw new Error('Image upload failed.')
        }
      }
      const headers = {
        Authorization: `Bearer ${user.token}`,
        'institute-Id': Number(id),
      }
      const payload = {
        ...newTeacher,
        teacher_image: imageUrl,
        headers,
      }

      const response = await ApiEndpoints.addTeacher({
        ...payload,
        password: newTeacher.password,
      })
      toast.success(response.data.message)

      // Reset form
      setNewTeacher({
        name: '',
        dob: '',
        age: '',
        qualification: '',
        phone: '',
        email: '',
        gender: '',
        address: '',
        password: '',
        joining_date: '',
        id_proof_type: '',
        id_proof_number: '',
        institute_id: institute.instituteId,
        designation: 'Teacher',
      })
      setTeacherImage(null)

      // Navigate back to TeacherList page
      navigate('/TeacherList')
    } catch (error) {
      toast.error(error.response?.message || 'Something went wrong.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
              }}
            >
              {/* Left: Logo, Title and Back Button */}
              <div className="d-flex align-items-center gap-3">
                {/* School Logo */}
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>

                <h3
                  className="m-0 fw-bold"
                  style={{
                    letterSpacing: '-0.02em',
                    overflow: 'visible',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#111827',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Add New Teacher
                </h3>
              </div>

              {!isMobile && <ProfileDropdown logout={logout} />}
            </div>
          </div>
        </div>

        <Container
          className="mt-4"
          style={{
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
            maxWidth: '1200px',
          }}
        >
          <Form onSubmit={handleSave}>
            <Row className="g-4">
              {/* Personal Details Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsPerson size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Personal Details
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-3">
                      <Form.Label>Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={newTeacher.name}
                        onChange={handleInputChange}
                        placeholder="Enter Teacher's Name"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth *</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={newTeacher.dob}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Age</Form.Label>
                      <Form.Control
                        type="text"
                        name="age"
                        value={newTeacher.age}
                        disabled
                        className="p-2 border rounded bg-light"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Gender *</Form.Label>
                      <Form.Select
                        name="gender"
                        value={newTeacher.gender}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Qualification *</Form.Label>
                      <Form.Control
                        type="text"
                        name="qualification"
                        value={newTeacher.qualification}
                        onChange={handleInputChange}
                        placeholder="Enter Qualification"
                        required
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              {/* ID Proof & Contact Details Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsPersonBadge size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        ID Proof & Contact Details
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-3">
                      <Form.Label>ID Type *</Form.Label>
                      <Form.Select
                        name="id_proof_type"
                        value={newTeacher.id_proof_type}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select</option>
                        <option value="aadhar card">Aadhaar</option>
                        <option value="voter card">Voter ID</option>
                        <option value="license">License</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>ID Proof Number *</Form.Label>
                      <Form.Control
                        type="number"
                        name="id_proof_number"
                        value={newTeacher.id_proof_number}
                        onChange={handleInputChange}
                        placeholder="Enter ID Proof Number"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number *</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={newTeacher.phone}
                        onChange={handleInputChange}
                        placeholder="Enter Phone Number"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Email ID *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={newTeacher.email}
                        onChange={handleInputChange}
                        placeholder="Enter Email ID"
                        required
                      />
                    </Form.Group>



                    <Form.Group className="mb-3">
                      <Form.Label>Designation</Form.Label>
                      <Form.Control
                        type="text"
                        name="designation"
                        value={newTeacher.designation}
                        onChange={handleInputChange}
                        placeholder="e.g. Teacher, HOD"
                        className="p-2 border rounded"
                      />
                    </Form.Group>

                    
                    {/* <Form.Group className="mb-3">
                      <Form.Label>Institute</Form.Label>
                      <FormSelect
                        name="institute_id"
                        value={institute.instituteId}
                        disabled
                      >
                        <option value={institute.instituteId}>{institute.name}</option>
                      </FormSelect>
                    </Form.Group> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row className="g-4 mt-0">
              {/* Account & Joining Details Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsCalendar size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Account & Joining Details
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-3">
                      <Form.Label>Password *</Form.Label>
                      <div className="input-group">
                        <Form.Control
                          type={showPassword ? 'text' : 'password'}
                          name="password"
                          value={newTeacher.password}
                          onChange={handleInputChange}
                          placeholder="Enter Password"
                          required
                        />
                        <Button
                          variant="outline-secondary"
                          onClick={togglePasswordVisibility}
                          title={showPassword ? 'Hide Password' : 'Show Password'}
                          style={{
                            borderLeft: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </Button>
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-0">
                      <Form.Label>Date of Join *</Form.Label>
                      <Form.Control
                        type="date"
                        name="joining_date"
                        value={newTeacher.joining_date}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              {/* Address & Image Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsGeoAlt size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Address & Image
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-3">
                      <Form.Label>Address *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="address"
                        value={newTeacher.address}
                        onChange={handleInputChange}
                        placeholder="Enter Address"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-0">
                      <Form.Label>Teacher Image (PNG/JPG/JPEG)</Form.Label>
                      <div className="d-flex align-items-center gap-3 mt-2">
                        <Form.Control
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          onChange={(e) => setTeacherImage(e.target.files[0])}
                        />
                        {teacherImage && (
                          <img
                            src={URL.createObjectURL(teacherImage)}
                            alt="Preview"
                            style={{
                              width: 100,
                              height: 100,
                              objectFit: 'cover',
                              borderRadius: 8,
                              border: '1px solid #ccc',
                            }}
                          />
                        )}
                      </div>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-3 mt-4 pt-3" style={{ borderTop: '1px solid #E5E7EB' }}>
              <Button
                onClick={() => navigate('/TeacherList')}
                disabled={loading}
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: '#6b7280',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: '15px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '140px',
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.backgroundColor = '#F3F4F6'
                    e.currentTarget.style.borderColor = '#9ca3af'
                    e.currentTarget.style.color = '#111827'
                    e.currentTarget.style.transform = 'translateY(-1px)'
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.color = '#6b7280'
                  e.currentTarget.style.transform = 'translateY(0)'
                }}
              >
                <BsXLg size={16} />
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={loading}
                style={{
                  backgroundColor: loading ? '#9ca3af' : '#10B981',
                  border: 'none',
                  color: '#ffffff',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: '15px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '160px',
                  boxShadow: loading ? 'none' : '0 2px 4px rgba(16, 185, 129, 0.2)',
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.backgroundColor = '#059669'
                    e.currentTarget.style.transform = 'translateY(-1px)'
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(16, 185, 129, 0.3)'
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.currentTarget.style.backgroundColor = '#10B981'
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(16, 185, 129, 0.2)'
                  }
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '14px', height: '14px', borderWidth: '2px' }}></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <BsCheckLg size={16} />
                    Save
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  )
}

export default AddNewTeacher

